import styled from "styled-components";
import { HeadLine1, BodySmall } from "../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  position: relative;
  gap: 10px;
`;

export const InstanceName = styled(HeadLine1)`
  color: ${({ theme }) => theme.palette[800]};
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const NavWrapper = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  margin-right: 10px;
  margin-top: 40px;
  & > div {
    position: absolute;
    bottom: -1px;
    left: 0px;
  }
`;

export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  justify-content: space-between;
  width: 100%;
  margin-right: 10px;
`;

export const Section = styled.div`
  background: ${({ theme }) => theme.base.white};
  border: 1px solid ${({ theme }) => theme.grey[350]};
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
`;

export const SectionTitle = styled(BodySmall)`
  color: ${({ theme }) => theme.palette[700]};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;
